import { type DepositAccount } from '@fruitful/income-split';

import { requestBuilder } from '../../../http/RequestBuilder';

const useGetAccountsForMembership = requestBuilder.query<
    DepositAccount[],
    { membershipId: string }
>({
    endpoint: ({ membershipId }) =>
        `/api/admin/banking/accounts/membership/${membershipId}`,
    queryKey: ({ membershipId }) =>
        `useGetAccountsForMembership/${membershipId}`,
});

export default useGetAccountsForMembership;
